import NotificationService from 'services/notificationService';

const GetSendGridTemplate = async (
  getAuthToken: () => Promise<string | void>,
  templateName: string
): Promise<string | undefined> => {
  const authToken = await getAuthToken();
  if (!authToken) return;

  const service = new NotificationService(authToken);
  const result = await service.notificationService.get('GetSendGridTemplate', { templateName });

  return result.data;
};

export default GetSendGridTemplate;
